import { createFileRoute, redirect } from '@tanstack/react-router'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'
import { getCookie } from '@/lib/cookies';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    if (!getCookie("token")) {
      throw redirect({
        to: '/login',
      });
    }
    let verifyToken = await context.auth.verify();
    if (verifyToken == null || !verifyToken) {
      throw redirect({
        to: '/login',
      });
    }
    if (context.auth.loading == false && !context.auth.user) {
      throw redirect({
        to: '/login',
      });
    }
    if (context.auth.loading == false && !context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
      });
    }
    let permitted = await context.auth.checkPermissions();
    if (permitted == false || permitted == null) {
      context.auth.logout();
      throw redirect({
        to: '/login'
      });
    }
  },
  component: AuthenticatedLayout,
})
